import { useGamesStore } from '../../store';

export const useGetGameLiveDataByLaunchId = (launchId: string | number) => {
  return useGamesStore(
    (store) => store.gamesLiveInfo.launchIdToGameLiveData[launchId]
  );
};
